"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationRuleTypeEnum = exports.AutomationRuleStatusEnum = void 0;
var AutomationRuleStatusEnum;
(function (AutomationRuleStatusEnum) {
    AutomationRuleStatusEnum["ACTIVE"] = "Active";
    AutomationRuleStatusEnum["INACTIVE"] = "Inactive";
})(AutomationRuleStatusEnum || (exports.AutomationRuleStatusEnum = AutomationRuleStatusEnum = {}));
var AutomationRuleTypeEnum;
(function (AutomationRuleTypeEnum) {
    AutomationRuleTypeEnum["ABBY"] = "AbbyFlexicaptureCloud";
    AutomationRuleTypeEnum["EMAIL"] = "Email";
    AutomationRuleTypeEnum["REFINEMENT_INFLOW"] = "RefinementInflow";
    AutomationRuleTypeEnum["REFINEMENT_OUTFLOW"] = "RefinementOutflow";
    AutomationRuleTypeEnum["REFINEMENT_TARGET_FOLDER"] = "RefinementTargetFolder";
    AutomationRuleTypeEnum["WORKATO"] = "Workato";
})(AutomationRuleTypeEnum || (exports.AutomationRuleTypeEnum = AutomationRuleTypeEnum = {}));
//# sourceMappingURL=automation.js.map